import React, { createRef, PureComponent } from 'react';
import { get } from 'lodash';
import TranslatedCopy from '../../intl/translated-copy';
import {
  Form,
  Field,
  reduxForm,
  reset,
  change,
} from 'redux-form';
import { connect } from 'react-redux';
import Btn from '../global/button';
import KeyMap from '../../utilities/keymap';
import {
  getPos,
  removeTabIndex,
} from '../../utilities/helpers';
import { injectThreatMetrixAdvancedProfilingScript } from '../../utilities/advanced-profile.js';
import FormInputText from '../../components/global/form-input-text';
import {
  clubPremierNumber,
  dayB,
  // se comenta linea por bloqueo de email emailClubPremierNumber,
  lastName,
  monthB,
  password,
  yearB,
} from '../../validation/validation';
import Tooltip from './tooltip';
import Loading from './loading-screen';
import cx from 'classnames';
import AlertWarningError from '../profile/alert-warning-error';
import { LOGIN_VIEW, REGISTER, REGISTER_VIEW } from '../../../redux/actions/Interaction-studio-action-creators';
import {
  getErrorMessage,
  recoverAccountReset,
  recoverOtpSettingsReset,
  removeCodeError,
  removeStatusCodeError,
  resendOtpLogin,
  resetCPnumber,
  resetLoginSuccessCount,
  retrieveIpAddress,
  retrieveSessionTM,
  retrieveTouchPoints,
  setSignInState,
  submitAccountPasswordPinReset,
  userGetOtpStart,
  userSignInAction,
  userSignUpAction,
  userSignUpSendOtp,
} from '../../../redux/actions/index';
import Recaptcha from 'react-google-invisible-recaptcha';
import UserProfileSuccessRegistration from '../profile/user-profile-success-registration-cp';
import UserProfileRegistrationCP from '../profile/user-profile-registration-cp';
import UserProfileRegistrationConnectionError from '../profile/user-profile-registration-connection-error';
import UserProfileRegistrationDuplicateInfo from '../profile/user-profile-registration-duplicateInfo';
import PersistentLogin from './persistent-login';
import { USER_PROFILE_LOGIN_FORM_ID, USER_PROFILE_SIGNUP_FORM_ID } from '../../constants/form-ids';
import userProfileLoginValidation from '../../validation/user-profile-login-validation';
import CarouselTouchPoint from './carousel-touch-point';
import FormOTP from '../profile/form-otp';
import formFieldCopyIDs from '../../constants/form-field-copy-ids';
import manageTracking from '../../analytics/creators/manage.js';
import { sendAnalytics } from '../../analytics/tracker';
import FormInputPhone from '../../components/global/form-input-phone';
import FormInputDateDropdown from '../../components/global/form-input-date-dropdown';
// import FormInputRadio from '../../components/global/form-input-radio';  // to log in with personal or corporate experience, should not be seen in production yet
import FormOtpLogin from '../profile/form-otp-login';
import FormOtpLoginError from '../profile/form-otp-login-error';
import FormOtpLoginConfirmation from '../profile/form-otp-login-confirmation';
import AccountNumberRecovery from '../profile/account-number-recovery.jsx';
import UserProfileRecoverPasswordPin from '../profile/user-profile-settings/user-profile-recover-password-or-pin.jsx';
import { sanitize } from 'dompurify';
import { bodyTextMarkdown } from '../../utilities/cms-helpers';
import TokenInvalidSecurityCard from './token-invalid-security-card.jsx';
import { setPendingOpenModalLogin } from '../../../redux/actions/profile-action-creators';

const GRECAPTCHA = process.env.REACT_APP_GRECAPTCHA;
const mapStateToProps = state => {
  return ({
    codeInicativeAccount: state.UserProfileSession.codeInicativeAccount,
    contentForm: state.form[USER_PROFILE_LOGIN_FORM_ID],
    contentFormRegistration: state.form[USER_PROFILE_SIGNUP_FORM_ID],
    enrollmentServiceError: state.Login.enrollmentServiceError,
    errorMessageCms: state.ErrorMessage.errorMessageCms,
    errorStatusCode: state.UserProfileSession.errorStatusCode,
    getOtpError: state.UserProfileSession.getOtpError,
    gralStore: state,
    helperTraslatedCopy: state.LanguageBundle.helperTraslatedCopy,
    infoTouchPoint: state.TouchPointsLogin.infoTouchPoint,
    ipAddress: state.UserProfileSession.ipAddress,
    isActivePersistentLoginPopup: state.UserProfileSession.isActivePersistentLoginPopup,
    isOtpSent: state.UserProfileSession.isOtpSent,
    isSignIn: state.UserProfileSession.isSignIn,
    language: state.Manage.language,
    loadingPorfileRequestStart: state.UserProfileSession.loadingPorfileRequestStart,
    loginSuccessCount: state.UserProfileSession.loginSuccessCount,
    metrixEmail: state.UserProfileSession.metrixEmail,
    otpServiceError: state.UserProfileSession.otpServiceError,
    profileRecoverAccount: state.Manage.profileRecoverAccount,
    sessionID: state.ProfileLogin.sessionID,
    signInFail: state.UserProfileSession.signInFail,
    signInFailCode: state.UserProfileSession.signInFailCode,
    stateStoreFront: state.Manage.stateStoreFront,
    storeFront: state.Manage.storefront,
    tokenInvalidSecurity: state.tokenInvalidSecurity,
    userProfile: state.UserProfileSession,
    userProfileCPNumber: state.UserProfileSession.userProfileCPNumber,
    userProfileSignUpSuccess: state.UserProfileSession.userProfileSignUpSuccess,
  });
};

class ModalLogin extends PureComponent {
  constructor(props) {
    super(props);

    const codeError = this.props.errorMessageCms?.errorMessages?.[0]?.errorMessage?.identifier;

    this.state = {
      activeLogin: true,
      activeOTP: false,
      activeRegistration: false,
      closeModalError: false,
      codeError,
      otpLoginConfirmationForm: false,
      otpLoginErrorForm: false,
      otpLoginForm: false,
      pwdPinOptionSelected: null,
      showForgotPassword: false,
      showPasswordRecovery: false,
      showWarningError: false,
      userPasswordRecoveryDone: false,
      userValuesForm : false,
      showAccountRecovery: false,
    };

    this.refRecaptcha = createRef();
    this.selectedRandomComponent = '';
    this.resetErrorModal = this.resetErrorModal.bind(this);
    this.handleRecoveryBackOnClick = this.handleRecoveryBackOnClick.bind(this);
  }

  componentDidMount() {
    const {
      activeRegister,
      dispatch,
      ipAddress,
      sessionID,
      stateStoreFront,
      tokenInvalidSecurity: {
        ffNumber,
      },
    } = this.props;

    dispatch(setPendingOpenModalLogin(false));

    if (sessionID === '') {
      dispatch(retrieveSessionTM());
    }

    if (!ipAddress) {
      dispatch(retrieveIpAddress());
    }

    if (activeRegister) {
      this.handleActiveRegistration();
    }

    if (!activeRegister) {
      dispatch(LOGIN_VIEW());
    }

    dispatch(retrieveTouchPoints(stateStoreFront.storefrontId));

    dispatch(sendAnalytics({
      eventCreator: manageTracking.userProfileRegistrationOtp('step 1', 'inicia sesión'),
    }));

    const components = ['phoneN', 'lastName', 'yearB', 'monthB', 'dayB'];
    const randomIndex = Math.floor(Math.random() * components.length);

    this.selectedRandomComponent = components[randomIndex];

    if (ffNumber.length > 0) {
      dispatch(change(USER_PROFILE_LOGIN_FORM_ID, 'emailClubPremierNumber', ffNumber));
    }
  }

  componentDidUpdate(prevProps, prevState ) {
    const {
      codeInicativeAccount,
      dispatch,
      isOtpSent,
      isSignIn,
      language,
      loadingPorfileRequestStart,
      loginSuccessCount,
      metrixEmail,
      onCloseLoginModal,
      sessionID,
      signInFail,
      signInFailCode,
      stateStoreFront,
      userProfileCPNumber,
      userProfileSignUpSuccess,
      valid,
    } = this.props;

    const { activeRegistration, userValuesForm } = this.state;
    const isValid = prevProps.valid !== valid && valid;
    const tabChange = prevState.activeRegistration !== activeRegistration && activeRegistration;
    const isValidatingData = prevProps.loadingPorfileRequestStart !== loadingPorfileRequestStart && !loadingPorfileRequestStart;
    const errorcodes = ['17531302', '17531304'];

    if (prevProps.metrixEmail !== metrixEmail && metrixEmail !== '') {
      this.setState({ otpLoginForm: true });
    }

    if (prevProps.signInFail !== signInFail) {
      this.setState({ showWarningError: true });
    }

    if (prevProps.signInFailCode !== signInFailCode && errorcodes.includes(signInFailCode)) {
      this.setState({
        otpLoginConfirmationForm: true,
        otpLoginErrorForm: false,
        otpLoginForm: false,
      });
    }

    if (prevProps.loginSuccessCount !== loginSuccessCount && loginSuccessCount > 1) {
      this.setState({
        otpLoginConfirmationForm: true,
        otpLoginErrorForm: false,
        otpLoginForm: false,
      });
    }

    const isBehaviourSecurity = stateStoreFront?.isBehaviourSecurity;

    if (prevProps.sessionID !== sessionID) {
      if (!isBehaviourSecurity) {
        const script = document.createElement('script');
        const head = document.querySelector('head');
        script.src = 'https://content.clubpremier.com/fp/tags.js?org_id=7d66bbvt&session_id=' + sessionID;
        head.appendChild(script);
      } else {
        injectThreatMetrixAdvancedProfilingScript(sessionID);
      }
    }

    if (prevProps.isSignIn !== isSignIn && isSignIn) {
      onCloseLoginModal();
    }

    if (prevProps.codeInicativeAccount !== codeInicativeAccount && codeInicativeAccount) {
      dispatch(getErrorMessage(codeInicativeAccount, language));

      if (codeInicativeAccount === '17531301') {
        this.setState({
          otpLoginConfirmationForm: false,
          otpLoginErrorForm: true,
          otpLoginForm: false,
        });
      }
    }

    if (isValidatingData && this.refRecaptcha && this.refRecaptcha.current && this.refRecaptcha.current.reset) {
      this.refRecaptcha.current.reset();
    }

    if (tabChange || isValid ) {
      dispatch(removeCodeError(true));
    }

    if (prevProps.userProfileCPNumber !== userProfileCPNumber && userProfileSignUpSuccess) {
      const {
        birthdayDate,
        dayB,
        email,
        firstName,
        lastName,
        monthB,
        yearB,
        yearDate,
      } = userValuesForm;

      const registerCustomEvent = {
        'ffn_dp_id': userProfileCPNumber,
        'nombre': firstName,
        'apellido': lastName,
        'emailAddress': email,
        'cumpleanos': birthdayDate,
        'yearDate': yearDate,
        'dayB': dayB,
        'monthB': monthB,
        'yearB': yearB,
      };
      dispatch(REGISTER(registerCustomEvent));
    }

    if (prevProps.isOtpSent !== isOtpSent && isOtpSent) {
      this.setState({
        activeLogin: false,
        activeOTP: true,
        activeRegistration: false,
      });
    }
  }

  componentWillUnmount() {
    localStorage.removeItem('isLoginForm');
    const htmlTag = document.getElementsByTagName('html')[0];
    htmlTag.classList.remove('Modal-open--state');
  }

  render() {
    const {
      dispatch,
      isSignedIn,
      loadingPorfileRequestStart,
      storeFront,
      userProfileSignUpSuccess,
      userProfileCPNumber,
    } = this.props;

    const {
      userValuesForm,
    } = this.state;

    const showSuccessRegistration = userProfileCPNumber && userProfileSignUpSuccess && !isSignedIn;
    return (
      <div className='ModalLogin'>
        <div className='Modal-inner-login'>
          <div className='Modal-overlay Modal-overlay--isOpen'></div>
          <div className='Modal-body-login Modal-body--isOpen Modal-body--regular has-noDefaultTopBar' tabIndex='0'>
            <section className='ModalLogin-heading'>
              <span className='UserProfileModal-headerIcon Icon Icon--profileNew' />
              <TranslatedCopy className='ModalLogin--title' copyID='PRO_HOME2.0_MY_PROFILE' />
              <button className='Modal-close Icon Icon--xThin'
                id='idModalClose'
                onClick={ this.closeModalLogin } >
              </button>
            </section>
            { showSuccessRegistration ?
              <UserProfileSuccessRegistration
                contentForm={ userValuesForm }
                dispatch={ dispatch }
                loadingPorfileRequestStart={ loadingPorfileRequestStart }
                storefront={ storeFront }
                userProfileCPNumber={ userProfileCPNumber }
              />
              : this.ModalLoginAndRegisterCP()
            }
          </div>
        </div>
      </div>
    );
  }

  ModalLoginAndRegisterCP = () => {
    const {
      dispatch,
      enrollmentServiceError,
      errorStatusCode,
      getOtpError,
      otpServiceError,
      apiError,
    } = this.props;

    const {
      activeOTP,
      showPasswordRecovery,
    } = this.state;

    const showLoginRegisterTab = !activeOTP && !showPasswordRecovery;
    if (getOtpError === '17331314') {
      return (
        <UserProfileRegistrationConnectionError
          closeModalLogin={ this.closeModalLogin }
          dispatch={ dispatch }
          getOtpError={ getOtpError }
          handleActiveRegistration={ this.handleActiveRegistration } />
      );
    }

    if (!enrollmentServiceError && !otpServiceError) {
      return (
        <div>
          { showLoginRegisterTab && this.ModalLoginRegisterBtns() }
          { this.ModalLoginCP() }
        </div>
      );
    }

    if ( apiError && enrollmentServiceError || apiError && otpServiceError ) {
      return (
        <UserProfileRegistrationConnectionError
          closeModalLogin={ this.closeModalLogin }
          dispatch={ dispatch }
          getOtpError={ getOtpError }
          handleActiveRegistration={ this.handleActiveRegistration } />
      );
    }

    if (errorStatusCode === '17111310') {
      return (
        <UserProfileRegistrationDuplicateInfo
          dispatch={ dispatch }
          handleActiveRegistration={ this.handleActiveRegistration } />
      );
    }

    return (
      <UserProfileRegistrationConnectionError
        closeModalLogin={ this.closeModalLogin }
        dispatch={ dispatch }
        handleActiveRegistration={ this.handleActiveRegistration } />
    );
  }

  ModalLoginRegisterBtns = () => {
    const {
      activeLogin,
      activeRegistration,
    } = this.state;

    return (
      <div className='ModalLogin-btn-container' key='ModalLogin-btn-container'>
        <button
          className={ `ModalLogin-btn ${activeLogin ? 'ModalLogin-btn-active' : ''}` }
          key='btnActiveLogin'
          onClick={ () => this.handleActiveLogin() }
        >
          <TranslatedCopy
            copyID='PRO_HOME2.0_LOGIN'
          />
        </button>
        <button
          className={ `ModalLogin-btn ${activeRegistration ? 'ModalLogin-btn-active' : ''}` }
          key='btnActiveSignup'
          onClick={ () => this.handleActiveRegistration() }
        >
          <TranslatedCopy
            copyID='PRO_HOME2.0_SINGUP'
          />
        </button>
      </div>
    );
  }

  ModalLoginCP = () => {
    const {
      dispatch,
      language,
      storeFront,
    } = this.props;

    const {
      activeLogin,
      activeOTP,
      pwdPinOptionSelected,
      showAccountRecovery,
      showForgotPassword,
      showPasswordRecovery,
      userValuesForm,
    } = this.state;

    return (
      showForgotPassword && activeLogin ?
        null
        : activeLogin ?
          (!showPasswordRecovery) ?
            !showAccountRecovery ?
              this.renderLoginForm()
              :
              <AccountNumberRecovery
                closeModalLogin={ this.handleCloseLoginModal }
                onClickBack={ this.handleRecoveryBackOnClick }
                pwdPinOptionSelected={ pwdPinOptionSelected }
              />
            :
            <UserProfileRecoverPasswordPin
              dispatch={ dispatch }
              handleBackButtonClick={ this.backToLoginForm }
              handleCloseModal={ this.closeModalLogin }
              pwdPinOptionSelected={ pwdPinOptionSelected }
              toggleRecoveryAccount={ this.toggleRecoveryAccount }
            />
          : (activeOTP) ?
            <div className='ModalLogin-form-otp'>
              <FormOTP
                contentFormRegistration={ userValuesForm }
                dispatch={ dispatch }
                handleBackButtonClick={ this.handleBackButton }
                handleOtpValidSubmit={ this.handleOtpValidSubmit }
                language={ language }
                storeFront={ storeFront }
              />
            </div>
            :
            this.ModalRegisterCP()
    );
  }

  ModalRegisterCP = () => {
    const {
      codeInicativeAccount,
      dispatch,
      errorMessageCms,
      infoTouchPoint,
      loadingPorfileRequestStart,
    } = this.props;

    const itemInfoTouchPointInfo = infoTouchPoint.length > 0 && infoTouchPoint[0];
    const {
      color = null,
      isActive = '',
      itemsTouchPoints,
      subtitleTouchPoint,
      titleTouchPoint,
    } = itemInfoTouchPointInfo;

    const showCarousel = Boolean(itemInfoTouchPointInfo && itemsTouchPoints.length > 0 && isActive === 'true');

    const SignUpModalForm = cx({
      'SignUpModalForm': true,
      'LoadingSigUpModalForm': loadingPorfileRequestStart,
    });

    const mdTitle = bodyTextMarkdown(titleTouchPoint);
    const mdSubTitle = bodyTextMarkdown(subtitleTouchPoint);

    return (
      <div
        className={ SignUpModalForm }
        key='signUpModalForm' >
        { codeInicativeAccount &&
          <AlertWarningError
            codeInicativeAccount= { codeInicativeAccount }
            dispatch={ dispatch }
            messageCopyId={ errorMessageCms }
          />
        }

        { showCarousel ?
          <section className='ModalLogin-touchPoints-cp'>
            <div className='ModalLogin-touchPoints-cp-header'>
              <h4
                className='ModalLogin-touchPoints-cp-title'
                dangerouslySetInnerHTML={ { __html: sanitize(mdTitle) } } />
              <p
                className='ModalLogin-touchPoints-cp-subtitle'
                dangerouslySetInnerHTML={ { __html: sanitize(mdSubTitle) } } />
            </div>
            <CarouselTouchPoint
              itemsTouchPoints={ itemsTouchPoints }
              titleColor={ color }
            />
          </section>
          :
          <section className='ModalLogin-enrollmentTitle'>
            <div className='ModalLogin-enrollmentTitle-title'>
              <TranslatedCopy
                copyID={ formFieldCopyIDs.enrollmentTitle }
                id={ 'modal-login-enrollment-header-text' }
                spaceAfter={ true } />
            </div>
            <div className='ModalLogin-enrollmentTitle-description'>
              <TranslatedCopy
                copyID={ formFieldCopyIDs.enrollmentDescription }
                id={ 'modal-login-enrollment-header-description' }
                spaceAfter={ true } />
            </div>
          </section>
        }
        <UserProfileRegistrationCP
          onSignupSubmit={ this.handleSignupSubmit }
        />
        { loadingPorfileRequestStart &&
          <Loading
            seatmap={ true }
            isDataLoading={ true }
            type='airplaneWindow' /> }
      </div>
    );
  }

  handleSignupSubmit = () => {
    const {
      contentFormRegistration: { values },
      dispatch,
      gralStore,
      language,
      storeFront,
    } = this.props;

    this.setState({
      userValuesForm: values,
    });

    const request = values ? {
      email: values.email,
      name: values.firstName + ' ' + values.lastName,
    } : {};

    const pos = getPos(storeFront, language);

    dispatch(userSignUpSendOtp(request, pos, gralStore));
  }

  questions = {
    dayB:
    <Field
      autocompleteGroupName='bday'
      className='FormInput-wrapper UserProfileLogin-formInput UserProfileLoginForm-home FormImput-birthdayDate'
      component={ FormInputDateDropdown }
      content= {'dayB'}
      helperTraslatedCopy={ this.props.helperTraslatedCopy }
      isRequired={ true }
      key='inputBirthdayDate'
      label={ this.renderTextInputLabel({ name: 'birthdayDate', formFieldCopyID: 'dateOfBirth' }) }
      labelClassModifier='BirthDay'
      labelCopyID={ formFieldCopyIDs.userProfileLoginDay }
      name='dayB'
      setStateOnUpdate={ true }
      validate={ dayB }
      withDivider={ true }
    />,
    lastName:
    <Field
      className='FormInput-wrapper UserProfileLogin-formInput UserProfileLoginForm-home'
      component={ FormInputText }
      isRequired={ true }
      key='inputLastName'
      label={ this.renderTextInputLabel({ name: 'lastName', formFieldCopyID: 'lastNameRegister' }) }
      name='lastName'
      showIconInput={ true }
      validate={ lastName }
    />,
    monthB:
    <Field
      autocompleteGroupName='bday'
      className='FormInput-wrapper UserProfileLogin-formInput UserProfileLoginForm-home FormImput-birthdayDate'
      component={ FormInputDateDropdown }
      content= { 'monthB' }
      helperTraslatedCopy={ this.props.helperTraslatedCopy }
      isRequired={ true }
      key='inputBirthdayDate'
      label={ this.renderTextInputLabel({ name: 'birthdayDate', formFieldCopyID: 'dateOfBirth' }) }
      labelClassModifier='BirthDay'
      labelCopyID={ formFieldCopyIDs.userProfileLoginMonth }
      name='monthB'
      setStateOnUpdate={ true }
      validate={ monthB }
      withDivider={ true }
    />,
    phoneN:
    <Field
      autocomplete={ false }
      className='FormInput-wrapper UserProfileLogin-formInput UserProfileLoginForm-home UserProfileSignUp-telefono'
      component={ FormInputPhone }
      countryContent={ this.props.countryContent }
      inputClassModifier={ ['large', 'phone'] }
      isRequired={ true }
      key='inputPhone'
      label={ this.renderTextInputLabel({ name: 'phone', formFieldCopyID: 'billingPhone' }) }
      labelCopyID={ formFieldCopyIDs.userProfileLoginPhone }
      maxLength={ 4 }
      numberPhone={ true }
      name='phoneN'
      showIconInput={ true }
    />,
    yearB:
    <Field
      autocompleteGroupName='bday'
      className='FormInput-wrapper UserProfileLogin-formInput UserProfileLoginForm-home FormImput-birthdayDate'
      component={ FormInputDateDropdown }
      content= { 'yearB' }
      helperTraslatedCopy={ this.props.helperTraslatedCopy }
      isRequired={ true }
      key='inputBirthdayDate'
      label={ this.renderTextInputLabel({ name: 'birthdayDate', formFieldCopyID: 'dateOfBirth' }) }
      labelClassModifier='BirthDay'
      labelCopyID={ formFieldCopyIDs.userProfileLoginYear }
      name='yearB'
      setStateOnUpdate={ true }
      validate={ yearB }
      withDivider={ true }
    />,
  }

  renderFormInputLogin() {
    const {
      codeInicativeAccount,
      contentForm,
      dispatch,
      errorMessageCms,
      invalid,
      isActivePersistentLoginPopup,
      isSignIn,
      loadingPorfileRequestStart,
      stateStoreFront: {
        passwordResetProfile,
        recoverAccountProfile,
      },
      tokenInvalidSecurity: {
        tokenWasInvalid,
      },
      trackLoginUsername,
    } = this.props;

    const {
      closeModalError,
      showWarningError,
    } = this.state;

    const numbers = closeModalError;
    const email = isNaN(contentForm?.values?.emailClubPremierNumber) ? contentForm?.values?.emailClubPremierNumber : '';
    const errorPassword = (contentForm && contentForm?.syncErrors && contentForm?.syncErrors.password) ? contentForm.syncErrors.password : '';
    const showPersistentLoginMessage = !isSignIn && !isActivePersistentLoginPopup && localStorage.getItem('initials');
    if (trackLoginUsername) trackLoginUsername(email && !numbers ? 'mail' : 'AMR');

    const LoginModalForm = cx({
      'LoginModalForm': true,
      'LoadingLoginModalForm': loadingPorfileRequestStart,
    });

    // to log in with personal or corporate experience, should not be seen in production yet
    // const radioButtons = [
    //   {
    //     copyID:'Cuenta personal',
    //     value:'personal',
    //   },
    //   {
    //     copyID:'Cuenta corporativa',
    //     value:'corporate',
    //   },
    // ];

    // const radioButtonActiveIndex = radioButtons.findIndex(obj => obj.value === contentForm?.values?.accountTypeRadio);

    const ForgotPasswordClass = cx({
      'UserProfileLoginForm-forgotPassword': !passwordResetProfile,
    });

    const RecoverAccountClass = cx({
      'UserProfileLoginForm-recoverAccount': !recoverAccountProfile,
    });

    return (
      <>
        { codeInicativeAccount && codeInicativeAccount !== '500016' && showWarningError &&
          <AlertWarningError
            codeInicativeAccount={ codeInicativeAccount }
            dispatch={ dispatch }
            messageCopyId={ errorMessageCms }
          />
        }
        { showPersistentLoginMessage &&
            <PersistentLogin
              hiddeCTA={ true }
              onlyMessage={ true } />
        }
        <div className={ LoginModalForm } >
          { tokenWasInvalid && <TokenInvalidSecurityCard/> }
          { loadingPorfileRequestStart &&
            <Loading
              seatmap={ true }
              isDataLoading={ true }
              type='airplaneWindow' /> }
          <div className='LoginModalForm-section'>
            {/* radio buttons / options to log in with personal or corporate experience, should not be seen in production yet */}
            {/* <Field
              activeIndex={ radioButtonActiveIndex }
              buttons={ radioButtons }
              className='UserProfile-Login-Radio'
              component={ FormInputRadio }
              input={{
                name: 'accountTypeRadio',
                onChange: (val) => this.radioChange(val),
              }}
              name='accountTypeRadio' /> */}
            <div key='inputUser' onKeyDown={ (e) => this.onEnterClick(e) } >
              <Field
                className='LoginModalForm-formInput UserProfileLogin-formInput UserProfileLoginForm-home'
                component={ FormInputText }
                isRequired={ true }
                key='inputEmailCPNumber'
                // comentar linea por bloque de email labelCopyID={ numbers ? 'PRO_HOME_LOGIN_ACCOUNT' : 'PRO_HOME2.0_LOGIN_FIELD' }
                labelCopyID='PRO_HOME_LOGIN_ACCOUNT'
                maxLength={ 60 }
                minLength={ 5 }
                name='emailClubPremierNumber'
                numbers={ numbers }
                showIconInput={ true }
                // comentar linea por bloque de email type={ numbers ? 'number' : 'text' }
                type='number'
                // comentar linea por bloque de email validate={ numbers ? clubPremierNumber : emailClubPremierNumber }/>
                validate={ clubPremierNumber }/>
            </div>
            <div className={ RecoverAccountClass } >
              { recoverAccountProfile &&
                <button
                  className='UserProfileLoginForm-forgotPassword-inline'
                  onClick={ () => this.toggleRecoveryAccount(null) }
                  type='button'>
                  <TranslatedCopy copyID='PRO_HOME_FORGOT_MY_USER' />
                </button>
              }
            </div>
            { (email && !numbers) && this.renderRandomSecureInput() }
            <div key='inputPassword' onKeyDown={ (e) => this.onEnterClick(e) } >
              <Field
                className='LoginModalForm-formInput LoginModalForm-formInput--password UserProfileLogin-formInput UserProfileLoginForm-home'
                component={ FormInputText }
                errorClassName={ 'PnrInput-error' }
                errorMessageData={ errorPassword }
                isRequired={ true }
                key='inputPasswordLogin'
                labelCopyID={ this.renderPasswordLabel() }
                name='password'
                showIcon={ true }
                type={ 'password' }
                validate={ password }
              />
            </div>
            <div className={ ForgotPasswordClass }>
              { passwordResetProfile &&
                <button
                  onClick={ this.toggleRecoveryPassword }
                  className='UserProfileLoginForm-forgotPassword-inline'
                  type='button' >
                  <TranslatedCopy copyID='APP_FORGOT_MY_PASSWORD' />
                </button>
              }
            </div>
          </div>
          <div className='Form-submit LoginModalForm-submit'>
            <Btn
              block={ true }
              btnType='submit'
              copyID='APP_LOGIN'
              filled={ true }
              onBtnClick={ this.handleLocalOnCLick }
              visuallyDisabled={ invalid }
            />
            <div className='UserProfileLoginCapthcaOffVisible' >
              <Recaptcha
                onResolved={ this.handleOnLocalSubmit }
                ref={ this.refRecaptcha }
                sitekey={ GRECAPTCHA }
              />
            </div>
          </div>
          { this.renderFooterModalLogin() }
        </div>
      </>
    );
  }

  renderLoginForm = () => {
    const {
      errorMessageCms,
      signInFailCode,
    } = this.props;

    const {
      closeModalError,
      otpLoginConfirmationForm,
      otpLoginErrorForm,
      otpLoginForm,
    } = this.state;

    const closeModal = closeModalError;
    const errorMessage = errorMessageCms?.errorMessages?.[0]?.errorMessage?.identifier || false;
    const loginFormValue = otpLoginForm || otpLoginErrorForm || otpLoginConfirmationForm;

    return (
      <>
        { (!loginFormValue && (closeModal || (!errorMessage || errorMessage !== '500016'))) &&
          <Form>
            { this.renderFormInputLogin() }
          </Form>
        }
        { otpLoginForm &&
          <FormOtpLogin
            handleBackButtonClick={ this.backToLoginOTPForm }
            handleButtonSubmitClick={ this.toLoginOtpErrorForm }
            handleClick={ this.handleClick }
            showErrorAndHideButton={ false }
          />
        }
        { otpLoginErrorForm &&
          <FormOtpLoginError handleButtonClick={ this.toOtpLoginConfirmation }/>
        }
        { otpLoginConfirmationForm &&
          <FormOtpLoginConfirmation codeInicativeAccount={ signInFailCode } />
        }
      </>
    );
  }

  backToLoginOTPForm = () => {
    const {
      dispatch,
    } = this.props;

    dispatch(resetLoginSuccessCount());

    this.setState({
      activeLogin: true,
      activeRegistration: false,
      otpLoginForm: false,
      showWarningError: false,
    });
  }

  backToLoginForm = () => {
    const {
      dispatch,
    } = this.props;

    this.setState({
      activeLogin: true,
      activeRegistration: false,
      pwdPinOptionSelected: null,
      showPasswordRecovery: false,
    });

    dispatch(recoverOtpSettingsReset());
    dispatch(submitAccountPasswordPinReset());
  }

  toLoginOtpErrorForm = (enteredOtp) => {
    this.handleSubmit(enteredOtp);
  }

  toOtpLoginConfirmation = () => {
    this.setState({
      otpLoginConfirmationForm: false,
      otpLoginErrorForm: false,
      otpLoginForm: true,
    });
  }

  renderPasswordLabel = () => {
    return (
      <span>
        <TranslatedCopy
          copyID='APP_PASSWORD'
          spaceAfter={ true } />
        <Tooltip
          copyID='PASS_TOOLTIP'
          labelID='passtooltip-label'
          light={ false }
          position={ {
            'small': 'right',
            'medium': 'right',
            'medium-high': 'right',
            'large': 'right',
          } }
          tooltipID='passtooltip-tooltip' />
      </span>
    );
  }

  renderFooterModalLogin = () => {
    return (
      <div className='LoginModalForm-footer--container'>
        <div className='LoginModalForm-footer--element' >
          <div className='userProfile-noaccount'>
            <TranslatedCopy
              className='UserProfileLogin-footer UserProfileLogin-footer-captcha'
              copyID='USER_PROFILE_LEGAL_CAPTCHA'
              tagName='p' />
          </div>
        </div>
      </div>
    );
  }

  toggleRecoveryAccount = (fromPwdPin = null) => {
    this.setState({
      pwdPinOptionSelected: fromPwdPin,
      showAccountRecovery: true,
      showPasswordRecovery: false,
    });
  }


  toggleRecoveryPassword = () => {
    this.setState({ showPasswordRecovery: true });
  }
  // to log in with personal or corporate experience, should not be seen in production yet
  // radioChange(val) {
  //   const {
  //     dispatch,
  //   } = this.props;

  //   dispatch(change(USER_PROFILE_LOGIN_FORM_ID, 'accountTypeRadio', val));
  // }

  handleLocalOnCLick = (event) => {
    event.preventDefault();

    if (this.refRecaptcha && this.refRecaptcha.current) {
      this.refRecaptcha.current.execute();
    }

    localStorage.setItem('isLoginForm', true);
  }

  handleActiveLogin = () => {
    const { dispatch } = this.props;

    this.setState({
      activeLogin: true,
      activeRegistration: false,
    });

    dispatch(LOGIN_VIEW());

    dispatch(removeCodeError(true));

    dispatch(sendAnalytics({
      eventCreator: manageTracking.userProfileRegistrationOtp('step 1', 'inicia sesión'),
    }));
  }

  handleActiveRegistration = () => {
    const { dispatch } = this.props;

    this.setState({
      activeLogin: false,
      activeOTP: false,
      activeRegistration: true,
    });

    dispatch(removeCodeError(true));
    dispatch(removeStatusCodeError());
    dispatch(userGetOtpStart());
    dispatch(REGISTER_VIEW());
    dispatch(sendAnalytics({
      eventCreator: manageTracking.userProfileRegistrationOtp('step 1', 'inscribete'),
    }));
  }

  handleBackButton = () => {
    const {
      dispatch,
    } = this.props;

    this.setState({
      activeLogin: false,
      activeOTP: false,
      activeRegistration: true,
    });

    dispatch(userGetOtpStart());
    dispatch(sendAnalytics({
      eventCreator: manageTracking.userProfileRegistrationOtp('step 1', 'inscribete'),
    }));
  }

  handleClick = () => {
    const {
      dispatch,
      ffNumber,
    } = this.props;

    const dataToSend = {
      'ffNumber': ffNumber,
    };

    dispatch(resendOtpLogin(dataToSend));
  }

  handleOnLocalSubmit = () => {
    let value = null;

    if (this.refRecaptcha && this.refRecaptcha.current) {
      value = this.refRecaptcha.current.getResponse();
    }

    if (value) {
      this.handleSubmit();
    }
  }

  handleOtpValidSubmit = (otpCode = '') => {
    const {
      dispatch,
      gralStore,
    } = this.props;

    const {
      userValuesForm,
    } = this.state;

    let gender = '';

    switch (userValuesForm?.gender) {
      case 'M':
        gender = 'Male';
        break;
      case 'F':
        gender = 'Female';
        break;
      default:
        gender = 'Unspecified';
        break;
    }

    const request = userValuesForm ? {
      dateOfBirth: userValuesForm.birthdayDate,
      duplicateEmail: userValuesForm?.parent ? false : undefined,
      email: userValuesForm.email,
      firstName: userValuesForm.firstName,
      gender: gender,
      guardianAccount: userValuesForm?.parent,
      lastName: userValuesForm.lastName,
      middleName: userValuesForm?.middleName,
      nationality: userValuesForm.countryCode,
      nip: userValuesForm.telephonePIN,
      password: userValuesForm.SignUpPassword,
      phone: {
        'number': get(userValuesForm.phone, 'phoneNumber', ''),
        'countryCode': get(userValuesForm.phone, 'isoCode', 'MX'),
      },
      privacyPolicy: userValuesForm.privacyPolicy,
      privacyPolicyEuropean: userValuesForm?.isCountryEU,
      termsAndConditions: userValuesForm.userProfileTermsAndConditions,
      otpCode: otpCode,
    } : {};
    document.querySelector('.ModalLogin').scrollTop = 25;
    dispatch(userSignUpAction(request, gralStore));
  }

  handleSubmit = (enteredOtp = '') => {
    const {
      contentForm,
      dispatch,
      ipAddress,
      sessionID,
    } = this.props;

    if (localStorage.hasOwnProperty('position')) {
      const position = localStorage.getItem('position');
      window.scrollTo(0, position);
    }

    if (contentForm && contentForm.values && Object.values(contentForm.values)) {
      const clubPremierNumber = !isNaN(contentForm.values?.emailClubPremierNumber) ? contentForm.values?.emailClubPremierNumber : '';
      const email = isNaN(contentForm.values?.emailClubPremierNumber) ? contentForm.values?.emailClubPremierNumber : '';
      const password = contentForm.values?.password;

      dispatch(userSignInAction(clubPremierNumber, email, password, sessionID, enteredOtp, ipAddress));
    }
  }

  onEnterClick = (e) => {
    if ((e.keyCode === KeyMap.ENTER || e.keyCode === KeyMap.RETURN)) {
      this.handleLocalOnCLick();
    }
  }

  closeModalLogin = () => {
    const {
      dispatch,
      onCloseLoginModal,
      signInFailCode,
      userProfileCPNumber,
    } = this.props;

    const {
      otpLoginConfirmationForm,
    } = this.state;

    const errorcodes = ['17531302', '17531304'];
    const isSuccessPage = !errorcodes.includes(signInFailCode);

    if (otpLoginConfirmationForm && isSuccessPage) {
      dispatch(setSignInState());
    }

    if (userProfileCPNumber) {
      // limpiamos register
      dispatch(resetCPnumber());
      dispatch(reset(USER_PROFILE_SIGNUP_FORM_ID));
    }

    /*
      limpia el tabIndex para el redirect persistentLogin
      y que solo funcione con el modalLogin
    */
    dispatch(resetLoginSuccessCount());
    dispatch(submitAccountPasswordPinReset());
    dispatch(recoverOtpSettingsReset());
    dispatch(recoverAccountReset());
    removeTabIndex();
    onCloseLoginModal();
  }

  handleCloseLoginModal = (successView) => {
    const {
      dispatch,
    } = this.props;

    const {
      pwdPinOptionSelected,
    } = this.state;

    if (pwdPinOptionSelected && successView) {
      dispatch(recoverAccountReset());
      this.setState({
        showAccountRecovery: false,
        showPasswordRecovery: true,
      });
    } else {
      this.setState({
        pwdPinOptionSelected: null,
        showPasswordRecovery: false,
      });
      this.closeModalLogin();
    }
  }

  renderTextInputLabel(input) {
    return (
      input.formFieldCopyID &&
      <div>
        <TranslatedCopy
          copyID={ formFieldCopyIDs[input.formFieldCopyID] } 
          id={ `${ input.name }-label` }
          spaceAfter={ true } />
        { input.tooltipCopyID &&
          <Tooltip
            copyID={ input.tooltipCopyID }
            labelID={ `${ input.name }-label` }
            tooltipID={ `${ input.name }-tooltip` } 
          />}
      </div>
    );
  }

  resetErrorModal() {
    this.setState({ emailVerification: false });
  }

  handleRecoveryBackOnClick() {
    const {
      dispatch,
    } = this.props;

    this.setState({
      pwdPinOptionSelected: null,
      showAccountRecovery: false,
    });
    dispatch(recoverAccountReset());
  }
}

ModalLogin = reduxForm({
  destroyOnUnmount: true,
  form: USER_PROFILE_LOGIN_FORM_ID,
  validate: userProfileLoginValidation,
})(ModalLogin);

ModalLogin = connect(mapStateToProps)(ModalLogin);

export default ModalLogin;
